<template>
  <NuxtLayout name="default">
    <div class="china_exh_list">
      <div
        class="brand"
        style="margin-top: 20px">
        <a
          href="/"
          title="展会网"
          target="_blank">
          聚展
        </a>
        <el-icon>
          <ArrowRight />
        </el-icon>
        <a
          href="/wiki"
          title="展会百科"
          target="_blank">
          展会百科
        </a>
        <el-icon>
          <ArrowRight />
        </el-icon>
        <a
          :href="`/wiki-${secondIndustryId}-1/`"
          :title="`${secondIndustryName}展会百科`"
          target="_blank">
          {{ secondIndustryName }}展会百科
        </a>
      </div>
      <div class="kind">
        <div class="industry_container">
          <div
            v-for="(item, idx) in industry"
            :key="item.industryId"
            class="item">
            <div class="item_inner">
              <div class="industry-icon">
                <img v-lazy="getWebp(item.icon)" />
              </div>
              <div class="item_value">
                <p>{{ formatIndustry(item.industryName) }}</p>
              </div>
            </div>
            <span class="arrow"></span>
            <div
              class="hover_content"
              :style="subIndustry(idx)">
              <NuxtLink
                v-for="two in item.children"
                :key="two.id"
                :to="`/wiki-${two.id}-1/`"
                class="hover_content_item">
                {{ two.industryName }}
              </NuxtLink>
            </div>
          </div>
        </div>
      </div>
      <h1 style="font-size: 24px">{{ secondIndustryName }}展会百科</h1>
      <!-- 展会列表,不包含推荐 -->
      <template>
        <div
          v-if="fair && fair.records"
          class="exh_list">
          <div
            class="news_item"
            v-for="item in fair && fair.records ? fair.records : []"
            :key="item.id">
            <div class="news_img">
              <NuxtLink
                :to="`/wiki/${item.exhibitionId}-${item.id || 0}-0-0.html`"
                :title="item.exhibitionName"
                target="_blank">
                <img
                  v-lazy="
                    item.cover
                      ? `${item.cover}?x-oss-process=image/auto-orient,1/interlace,1/resize,m_fill,w_236,h_138/quality,q_90/watermark,image_bG9nby9qdXpoYW4ucG5nP3gtb3NzLXByb2Nlc3M9aW1hZ2UvcmVzaXplLFBfMTI,x_10,y_10`
                      : ''
                  "
                  :alt="item.exhibitionName" />
              </NuxtLink>
            </div>
            <div class="news_info">
              <p class="news_title">
                <NuxtLink
                  :to="`/wiki/${item.exhibitionId}-${item.id || 0}-0-0.html`"
                  :title="item.exhibitionName"
                  target="_blank">
                  <h2>{{ item.exhibitionName }}</h2>
                </NuxtLink>
              </p>
              <div class="news_abstract">
                {{ item.description }}
              </div>
              <div class="news_sub">
                <span
                  v-if="item.industryId && item.industryId.length > 0"
                  class="industry">
                  <NuxtLink
                    :to="`/information-${item.industryId[0]}-1/`"
                    :title="item.industryName + '资讯'"
                    target="_blank">
                    {{ item.industryName }}
                  </NuxtLink>
                </span>
                <span class="time">
                  {{ item.publishTime || item.createTime }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          style="margin: 12px 0; text-align: center; color: #999; padding: 40px">
          暂无数据
        </div>
      </template>
      <Pagination
        :total="fair.total"
        :page-size="pageSize"
        :current-page="pageNum"
        :use-a-link="true"
        :first-link="`/wiki-${secondIndustryId}-1/`"
        :link="`/wiki-${secondIndustryId}-`"
        :confirm-btn="true"
        @changePager="changePager" />
      <div
        class="data-total"
        id="data-total"
        style="display: none">
        {{ fair.total }}
      </div>
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
  import { defineAsyncComponent, computed } from 'vue'
  import { ArrowRight } from '@element-plus/icons-vue'
  import { useWikiList } from '~/composables/wiki/useWikiList'
  import { ELocale } from '~~/types/enums'
  import _ from 'lodash'
  import { getWebp } from '~/utils/common'

  const Pagination = defineAsyncComponent(() => import('~/components/Pagination/index.vue'))

  // 获取路由参数
  const route = useRoute()
  const { s: secondIndustryId = '0', page = '1' } = route.params

  // 使用 composable - SSR 模式下直接调用 fetchData
  const {
    industry,
    fair,
    secondIndustryName,
    title,
    langApi,
    pageNum,
    pageSize,
    fetchData,
    changePager,
    formatIndustry,
    subIndustry,
    formatTime,
    description,
    formatLogo,
    handleNewsUrl
  } = await useWikiList(secondIndustryId as string, ELocale.cn)

  // SSR 模式下直接获取数据
  await fetchData()

  // 页面头部设置 - SSR 模式
  useHead({
    title: `${title.value}-聚展`,
    meta: [
      {
        name: 'keywords',
        content: `${secondIndustryName.value}展会百科`
      },
      {
        name: 'description',
        content: `${secondIndustryName.value}展会百科，提供最新的展会信息、展会资讯、展会动态等`
      }
    ]
  })
</script>

<style lang="less" scoped>
  .china_exh_list {
    width: 1190px;
    margin: 0 auto;
    .brand {
      width: 1190px;
      font-size: 14px;
      line-height: 16px;
      padding: 8px;
      border-radius: 4px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      margin: auto;
      background: #fff;
      display: flex;
      align-items: center;
      a {
        font-size: 14px;
      }
    }
    .kind {
      width: 1190px;
      margin-top: 20px;
      background: #fff;
      border-radius: 10px;
      left: calc(50% - 595px);
      padding: 20px 28px 0;
      margin-bottom: 12px;

      .industry_container {
        padding: 0;
        display: flex;
        flex-wrap: wrap;

        .item {
          width: 97px;
          display: flex;
          margin-right: 48px;
          padding-bottom: 20px;
          flex-flow: column;
          position: relative;

          .arrow {
            display: none;
            position: absolute;
            top: 10px;
            left: calc(50% - 7px);
            width: 0;
            height: 0;
            border: 7px solid;
            border-color: transparent transparent #ddd;
          }

          &:hover {
            .hover_content {
              display: flex;
              flex-flow: wrap;
            }

            .arrow {
              display: block;
            }
          }

          .item_inner {
            display: flex;

            &:hover {
              cursor: pointer;
            }
          }

          &:nth-child(8n) {
            margin-right: 0;
          }

          .industry-icon {
            width: 19px;
            height: 20px;
            margin-right: 6px;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              width: auto;
              max-width: 19px;
              height: 20px;
            }
          }

          .item_value {
            font-size: 16px;
            color: #333;
            p {
              width: 110px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          .hover_content {
            position: absolute;
            width: 558px;
            top: 25px;
            z-index: 10;
            display: none;
            padding: 16px 24px 0;
            background: #fff;
            box-shadow:
              0 4px 4px rgba(10, 16, 20, 0.12),
              0 0 4px rgba(10, 16, 20, 0.12);
            border-radius: 6px;
            box-sizing: border-box;

            .hover_content_item {
              min-width: 60px;
              font-size: 15px;
              margin-right: 15px;
              margin-bottom: 16px;

              &:nth-child(7n) {
                margin-right: 0;
              }

              &:hover {
                color: #e50113;
              }
            }

            .active-industry {
              color: #e50113;
              font-weight: 700;
            }
          }
        }
      }
    }
    .exh_list {
      margin: 12px 0 0;

      .wiki_item {
        .name {
          font-size: 15px;
        }
        .desc {
          font-size: 13px;
        }
      }
      .news_item {
        padding: 16.5px 22px 16.5px 0;
        border-bottom: 1px dashed #d2d2d2;
        display: flex;

        &:last-child {
          border: none;
        }

        .news_img {
          width: 236px;
          height: 138px;
          border-radius: 4px;
          margin-right: 22px;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 236px;
            height: auto;
          }
        }

        .news_info {
          flex: 1;
          display: flex;
          flex-flow: column;
          justify-content: space-between;

          .news_title,
          h2 {
            font-size: 18px;
            font-weight: bold;
            color: #333;
          }

          .news_abstract {
            font-size: 16px;
            line-height: 28px;
            color: #666;
            overflow: hidden;
            text-align: justify;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .news_sub {
            font-size: 16px;
            color: #999;
            display: flex;
            align-items: center;

            .industry {
              margin-right: 16px;

              a {
                font-size: 14px;
                color: @app-color;
              }
            }

            .time {
              margin-right: 25px;
            }

            .watch {
              display: flex;
              align-items: center;
              line-height: 16px;

              .el-icon-look {
                margin-right: 4px;
              }
            }
          }
        }
      }
    }
  }
</style>
